import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    component: () => import(/* webpackChunkName: "base" */ '../views/Layout'),
    menu: false,
    desplegable: false,
    icon: '',
    redirect: '/inicio',
    meta: {
      permiso: [],
      requiresSession: true,
      title: 'Inicio',
    },
    children: [
      {
        path: '/inicio',
        name: 'Inicio',
        desplegable: false,
        icon: 'home',
        menu: false,
        meta: {
          permiso: [],
          title: 'Inicio',
          requiresSession: true,
        },
        children: [],
        component: () => import(/* webpackChunkName: "base" */ '../views/Home.vue'),
      },
      {
        path: '/perfil',
        name: 'Perfil',
        menu: false,
        desplegable: false,
        meta: {
          permiso: [],
          title: 'Perfil',
          requiresSession: true,
        },
        icon: 'home',
        children: [],
        component: () => import(/* webpackChunkName: "base" */ '../views/PerfilUsuario.vue'),
      },
      {
        path: '/403',
        name: 'Error403',
        menu: false,
        desplegable: false,
        meta: {
          permiso: [],
          requiresSession: true,
          title: 'No autorizado',
        },
        children: [],
        component: () => import(/* webpackChunkName: "base" */ '../views/auth/Error403.vue'),
      },
      {
        path: '/encuestas',
        name: 'Encuestas',
        component: () => import(/* webpackChunkName: "encuestas" */ '../views/encuestas/Encuesta.vue'),
        icon: 'mdi-file-document',
        menu: true,
        desplegable: false,
        meta: {
          permiso: ['verEncuestas'],
          requiresSession: true,
          title: 'Encuestas',
        },
        children: [
        ]
      },
      {
        path: 'crearencuesta/:id/:encuesta',
        name: 'Createencuesta',
        component: () => import(/* webpackChunkName: "encuestas" */ '../views/encuestas/Create.vue'),
        icon: '',
        menu: false,
        meta: {
          permiso: [],
          requiresSession: true,
          title: '',
        },
        children: []
      },
      {
        path: '/encuestas/panel/:id',
        name: 'Encuestaspanel',
        component: () => import(/* webpackChunkName: "encuestas" */ '../views/encuestas/Panel.vue'),
        icon: '',
        menu: false,
        meta: {
          permiso: [],
          requiresSession: true,
          title: '',
        },
        children: []
      },
      {
        path: '/reportes',
        name: 'Reportes',
        component: () => import(/* webpackChunkName: "reportes" */ '../views/index.vue'),
        icon: 'mdi-file-table-box-multiple-outline',
        menu: true,
        desplegable: true,
        meta: {
          title: 'Reportes',
          requiresSession: true,
          permiso: ['verReportes'],
        },
        children: [
          {
            path: '/reportes',
            name: 'Panel de reportes',
            component: () => import('../views/reportes/Reportes.vue'),
            icon: 'mdi-cash-multiple',
            menu: true,
            desplegable: false,
            meta: {
              title: 'Panel de reportes',
              requiresSession: true,
              permiso: ['verReportes'],
            },
            children: [
            ]
          },
        ]
      },
      
      {
        path: '/sistema',
        name: 'Configuraciones',
        component: () => import(/* webpackChunkName: "sistema" */ '../views/index.vue'),
        icon: 'mdi-cogs',
        menu: true,
        desplegable: true,
        meta: {
          title: 'configuraciones',
          requiresSession: true,
          permiso: ['verMaestro', 'verPersonas', 'verConfiguracionEncuesta', 'verReportes', 'verUser', 'verRol'],
        },
        children: [

          {
            path: '/sistema/maestra',
            name: 'Maestra',
            component: () => import(/* webpackChunkName: "sistema" */ '../views/sistema/Maestra.vue'),
            icon: 'mdi-apps',
            menu: true,
            desplegable: false,
            meta: {
              title: 'Maestra',
              requiresSession: true,
              permiso: ['verMaestro'],
            },
            children: [

            ]
          },
          {
            path: '/sistema/convenios',
            name: 'Convenios',
            component: () => import(/* webpackChunkName: "sistema" */ '../views/sistema/Convenios.vue'),
            icon: 'mdi-handshake',
            menu: true,
            desplegable: false,
            meta: {
              title: 'Convenios',
              requiresSession: true,
              permiso: ['verConvenios'],
            },
            children: [

            ]
          },
          {
            path: '/sistema/infointeres',
            name: 'Infointeres',
            component: () => import(/* webpackChunkName: "sistema" */ '../views/sistema/Infointeres.vue'),
            icon: 'mdi-bulletin-board',
            menu: true,
            desplegable: false,
            meta: {
              title: 'Inf. de interes',
              requiresSession: true,
              permiso: ['verConvenios'],
            },
            children: [

            ]
          },
          {
            path: '/sistema/personas',
            name: 'Personas',
            component: () => import(/* webpackChunkName: "sistema" */ '../views/sistema/personas/Personas.vue'),
            icon: 'mdi-briefcase-account',
            menu: true,
            desplegable: false,
            meta: {
              title: 'Personas',
              requiresSession: true,
              permiso: ['verPersonas'],
            },
            children: [

            ]
          },
          {
            path: '/sistema/personas/create',
            name: 'Personascreate',
            component: () => import(/* webpackChunkName: "sistema" */ '../views/sistema/personas/Create.vue'),
            icon: 'mdi-cube',
            menu: false,
            desplegable: false,
            meta: {
              title: 'Crear persona',
              requiresSession: true,
              permiso: ['verPersonas'],
            },
            children: [

            ]
          },
          {
            path: '/sistema/personas/update/:id',
            name: 'Personassupdate',
            component: () => import(/* webpackChunkName: "sistema" */ '../views/sistema/personas/Create.vue'),
            icon: 'mdi-cube',
            menu: false,
            desplegable: false,
            meta: {
              title: 'Actualizar persona',
              requiresSession: true,
              permiso: ['verPersonas'],
            },
            children: [

            ]
          },
          {
            path: '/sistema/encuestas',
            name: 'Historias',
            component: () => import(/* webpackChunkName: "sistema" */ '../views/historias/Historiasecciones.vue'),
            icon: 'mdi-cube',
            menu: true,
            desplegable: false,
            meta: {
              title: 'Encuestas',
              requiresSession: true,
              permiso: ['verConfiguracionEncuesta'],
            },
            children: [

            ]
          },
          {
            path: '/sistema/encuestas/createnuevo',
            name: 'Histcreatenuevo',
            component: () => import(/* webpackChunkName: "sistema" */ '../views/historias/CreateHistoria.vue'),
            icon: 'mdi-cube',
            menu: false,
            desplegable: false,
            meta: {
              title: 'Crear formulario',
              requiresSession: true,
              permiso: ['verConfiguracionEncuesta'],
            },
            children: [

            ]
          },
          {
            path: '/sistema/encuestas/updatenuevo/:id',
            name: 'Histupdatenuevo',
            component: () => import(/* webpackChunkName: "sistema" */ '../views/historias/CreateHistoria.vue'),
            icon: 'mdi-cube',
            menu: false,
            desplegable: false,
            meta: {
              title: 'Actualizar formulario',
              requiresSession: true,
              permiso: ['verConfiguracionEncuesta'],
            },
            children: [

            ]
          },
          {
            path: '/sistema/reportes',
            name: 'Configuracion de Reportes',
            component: () => import(/* webpackChunkName: "sistema" */ '../views/sistema/Reportes.vue'),
            icon: 'mdi-apps',
            menu: true,
            desplegable: false,
            meta: {
              title: 'reportes',
              requiresSession: true,
              permiso: ['verReportes'],
            },
            children: [

            ]
          },

        ]
      },
      {
        path: '/sistema/acceso',
        name: 'Control de accesos',
        component: () => import(/* webpackChunkName: "sistema" */ '../views/index.vue'),
        icon: 'mdi-account',
        menu: true,
        desplegable: true,
        meta: {
          title: 'accesos',
          requiresSession: true,
          permiso: ['verUser', 'verRol'],
        },
        children: [
          {
            path: '/sistema/acceso/usuarios',
            name: 'Usuarios',
            component: () => import(/* webpackChunkName: "sistema" */ '../views/sistema/control/User.vue'),
            icon: 'mdi-account',
            menu: true,
            desplegable: false,
            meta: {
              title: 'usuarios',
              permiso: ['verUser'],
              requiresSession: true,
            },
            children: []
          },
          {
            path: '/sistema/acceso/perfiles',
            name: 'Perfiles',
            component: () => import(/* webpackChunkName: "sistema" */ '../views/sistema/control/Roles.vue'),
            icon: 'mdi-badge-account-horizontal',
            menu: true,
            desplegable: false,
            meta: {
              title: 'perfiles',
              permiso: ['verRol'],
              requiresSession: true,
            },
            children: []
          }
        ]
      },
    ]
  },
  {
    path: '/cambioPassword/:token',
    component: () => import(/* webpackChunkName: "carnet" */ '../views/CambiarPass'),
    name: 'CambiarPass',
    menu: false,
    icon: '',
    meta: {
      permiso: [],
      requiresSession: false,
      title: 'cambiar contraseña',
    },
    children: []
  },
  {
    path: '/validar-carnet/:token',
    component: () => import(/* webpackChunkName: "carnet" */ '../views/ValidarQr'),
    name: 'ValidarCarnet',
    menu: false,
    icon: '',
    meta: {
      permiso: [],
      requiresSession: false,
      title: 'validar-carnet',
    },
    children: []
  },
  {
    path: '/',
    component: () => import(/* webpackChunkName: "auth" */ '../views/index'),
    menu: false,
    desplegable: false,
    icon: '',
    redirect: '/login',
    meta: {
      permiso: [],
      requiresSession: true,
      title: 'Login',
    },
    children: [
      {
        path: '/login',
        component: () => import(/* webpackChunkName: "auth" */ '../views/auth/Login'),
        name: 'login',
        menu: false,
        icon: '',
        meta: {
          permiso: [],
          requiresSession: false,
          title: 'Login',
        },
        children: []
      },
      {
        path: "*",
        component: () => import(/* webpackChunkName: "auth" */ '../views/auth/Error403'),
        name: '403',
        menu: false,
        icon: '',
        meta: {
          permiso: [],
          requiresSession: false,
          title: 'Pagina no encontrada',
        },
        children: [

        ]
      },
    ]
  }
];
const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router